import { resources } from "@constants/hardcoded-strings";
import { formatMessageTemplate } from "@formatters/message-templates/message-template-formatter";
import { MultiLanguageWrapper } from "@iddataweb/idw-common-ui/types";
import { MessageTemplate } from "@idw-types/data/message-template";
import { AxnCompany } from "@idw-types/data/reference-data/axn";
import { addObjectsToArrayInCommonReferenceData } from "@redux/actions/common-reference-data-actions";
import { addMessageTemplate } from "@redux/actions/message-templates-actions";
import { createMessageTemplateRequest } from "@requests/axnadmin-core/create-message-template";
import { displaySuccessModal, logAndDisplayErrorModal } from "@utils/app-alert-util";
import { Dispatch } from "redux";
import { v4 as uuidv4 } from "uuid";

export const createMessageTemplateReduxRequest = (dispatch: Dispatch) => async (
    template: string,
    name: string,
    companyId: string,
    sender: string,
    type: string,
    languages: Partial<MultiLanguageWrapper<string>>,
    axnCompanies: Array<AxnCompany>,
    addToReferenceData: boolean
): Promise<MessageTemplate> => {
    const { data, error, body } = await createMessageTemplateRequest(
        template,
        name,
        companyId,
        languages,
        sender,
        type,
    );

    if (data) {

        const messageTemplate: MessageTemplate = {
            organizationID: data?.response.organizationID,
            rpServiceID: data?.response.rpServiceID,
            id: data?.response.id,
            template: data?.response.template,
            sender: data?.response.sender,
            languages: data?.response.languages,
            name: data?.response.name,
            type: data?.response.type,
            status: data?.response.status,
            permissions: {
                canModify: true,
                canView: true,
                canCreate: true,
            },
            uuid: uuidv4(),
        };

        if (addToReferenceData) {
            dispatch(addObjectsToArrayInCommonReferenceData([messageTemplate], "messageTemplate"));
        } else {
            const formattedMessageTemplate = formatMessageTemplate(
                messageTemplate,
                axnCompanies,
            );
            dispatch(addMessageTemplate(formattedMessageTemplate));
        }

        displaySuccessModal(
            dispatch,
            resources.requests.createMessageTemplate.success.title,
            resources.requests.createMessageTemplate.success.message
        );
        return data?.response;
    } else if (error) {
        logAndDisplayErrorModal(
            dispatch,
            error,
            resources.requests.createMessageTemplate.error.title,
            resources.requests.createMessageTemplate.error.message,
            null,
            null,
            body
        );
    }

    return null;
};